<template>
  <div id="bottom-compos" class="black-bg pb-60" :class="screenWidth>768?'pt-240':'pt-220 pl-20 pr-20'">
    <div class="wrapper white">
      <div class="bottom-icon">
        <span class="dis-ib bottom-icon-item" @click="router('/')">
          <svg x="0px" y="0px" viewBox="0 0 307.6 306.7">
            <polygon fill="#ffffff" points="147.9,5.7 302.1,5.7 302.1,159.9 " />
            <circle fill="#ffffff" cx="70.2" cy="70.2" r="70.2" />
            <circle fill="#ffffff" cx="237.4" cy="236.6" r="70.2" />
            <rect fill="#ffffff" x="5.8" y="172.1" class="st0" width="130.3" height="130" />
          </svg>
        </span>
      </div>
      <el-row :gutter="screenWidth>1920?80:screenWidth>=1200&&screenWidth<1920?80:screenWidth>=992&&screenWidth<1200?50:screenWidth>=768&&screenWidth<992?30:0">
        <el-col :span="8" :xs="24">
          <div>
            <div class="bottom-logo">
              <svg version="1.1" x="0px" y="0px" viewBox="0 0 195.3 27.8">
                <g fill="#ffffff">
                  <path d="M6.9,25.8C4.7,24.6,3,23,1.8,21c-1.2-2-1.8-4.2-1.8-6.6c0-2.6,0.7-5,2-7.1c1.4-2.1,3.2-3.7,5.6-4.8c2.4-1.2,5-1.7,8-1.7c1.3,0,2.6,0.1,3.9,0.3s2.4,0.5,3.2,0.8c0.2,0.1,0.4,0.2,0.5,0.3c0.1,0.1,0.1,0.3,0.1,0.6l0.5,5.7c0,0.1-0.1,0.1-0.2,0.2s-0.2,0-0.3-0.1c-1-2.1-2.3-3.8-4-5c-1.7-1.2-3.6-1.8-5.8-1.8c-2.8,0-4.9,1-6.4,2.9S5,9.5,5,12.8c0,2.7,0.5,5.1,1.4,7.3c0.9,2.1,2.2,3.8,3.9,5s3.5,1.7,5.6,1.7c1.1,0,2-0.1,2.6-0.4c0.6-0.2,1-0.7,1.3-1.4c0.3-0.7,0.4-1.8,0.4-3.2c0-1.4-0.1-2.4-0.2-3c-0.2-0.6-0.5-1-1-1.1c-0.5-0.2-1.5-0.3-2.8-0.3c-0.2,0-0.2-0.1-0.2-0.3c0-0.1,0-0.2,0.1-0.2c0-0.1,0.1-0.1,0.1-0.1c2.3,0.1,4.2,0.2,5.7,0.2c1.4,0,2.9,0,4.4-0.1c0,0,0.1,0,0.1,0.1c0,0.1,0.1,0.1,0.1,0.2c0,0.2-0.1,0.3-0.2,0.3c-0.5,0-0.8,0.1-1,0.3c-0.2,0.2-0.3,0.6-0.4,1.2c0,0.6-0.1,1.7-0.1,3.3c0,1.2,0,2.1,0.1,2.6c0.1,0.5,0.1,0.9,0.1,1c0,0.2,0,0.3-0.1,0.3c-0.1,0-0.2,0.1-0.4,0.2c-3.6,0.8-6.7,1.2-9.6,1.2C11.8,27.5,9.2,26.9,6.9,25.8z" />
                  <path d="M48.2,20.4c0.1,0,0.2,0,0.2,0.1c0.1,0,0.1,0.1,0.1,0.1c-0.3,2.1-0.4,4.1-0.4,5.9c0,0.2,0,0.4-0.1,0.5C47.9,27,47.8,27,47.5,27H29.3c-0.1,0-0.1-0.1-0.1-0.2c0-0.2,0-0.2,0.1-0.2c0.9,0,1.5-0.1,1.9-0.2c0.4-0.1,0.7-0.4,0.8-0.8c0.1-0.4,0.2-1,0.2-1.8V4.6c0-0.8-0.1-1.4-0.2-1.8c-0.1-0.4-0.4-0.7-0.8-0.8c-0.4-0.2-1-0.2-1.9-0.2c-0.1,0-0.1-0.1-0.1-0.2s0-0.2,0.1-0.2h17.5c0.3,0,0.4,0.1,0.4,0.4l0.1,5.5c0,0-0.1,0.1-0.2,0.1s-0.2,0-0.3-0.1c-0.4-1.6-1.2-2.8-2.2-3.6c-1-0.8-2.4-1.2-4.1-1.2h-1.2c-0.8,0-1.4,0.2-1.8,0.5c-0.4,0.4-0.6,0.9-0.6,1.7V13h3.4c1.6,0,2.8-0.3,3.7-0.8c0.9-0.5,1.3-1.3,1.3-2.3c0-0.1,0.1-0.1,0.2-0.1c0.2,0,0.2,0,0.2,0.1l0,3.7l0,2c0,0.9,0.1,1.7,0.1,2.2c0,0-0.1,0.1-0.2,0.1s-0.2,0-0.2-0.1c0-1.1-0.4-2-1.3-2.6c-0.9-0.7-2.1-1-3.7-1h-3.4v9.3c0,0.8,0.2,1.4,0.5,1.8s0.8,0.6,1.4,0.6h1.4c2.1,0,3.9-0.4,5.2-1.3S47.5,22.3,48.2,20.4C48,20.4,48.1,20.4,48.2,20.4z" />
                  <path d="M58.6,25.7c-2-1.2-3.5-2.8-4.6-4.9c-1.1-2-1.6-4.3-1.6-6.7c0-2.8,0.7-5.2,2.1-7.3c1.4-2,3.3-3.5,5.5-4.5c2.2-1,4.5-1.5,6.9-1.5c2.6,0,4.9,0.6,6.9,1.8c2,1.2,3.5,2.8,4.5,4.8c1.1,2,1.6,4.1,1.6,6.4c0,2.5-0.7,4.8-2,6.9c-1.3,2.1-3.1,3.7-5.3,5c-2.2,1.2-4.6,1.8-7.2,1.8C62.9,27.5,60.6,26.9,58.6,25.7z M70.9,25.1c1.2-0.9,2.2-2.2,2.9-3.9c0.7-1.7,1-3.8,1-6.2c0-2.5-0.4-4.8-1.2-6.8s-1.9-3.6-3.3-4.7c-1.4-1.1-3.2-1.7-5.1-1.7c-2.5,0-4.4,1-5.8,2.8c-1.3,1.9-2,4.5-2,7.9c0,2.7,0.4,5,1.2,7.1c0.8,2.1,1.9,3.7,3.3,4.9c1.4,1.2,3,1.8,4.8,1.8C68.3,26.5,69.7,26,70.9,25.1z" />
                  <path d="M112.2,26.8c0,0.2,0,0.2-0.1,0.2c-1,0-1.7,0-2.3,0l-3.2,0l-3.7,0c-0.5,0-1.2,0-2,0c-0.1,0-0.1-0.1-0.1-0.2c0-0.2,0-0.2,0.1-0.2c1,0,1.8-0.1,2.2-0.2c0.5-0.1,0.8-0.4,1-0.8c0.2-0.4,0.2-1,0.2-1.9v-9.5H91v9.5c0,0.8,0.1,1.4,0.2,1.8c0.2,0.4,0.5,0.7,1,0.8c0.5,0.1,1.2,0.2,2.2,0.2c0,0,0.1,0.1,0.1,0.2c0,0.2,0,0.2-0.1,0.2c-1,0-1.7,0-2.3,0l-3.6,0l-3.1,0c-0.5,0-1.3,0-2.3,0c0,0-0.1-0.1-0.1-0.2c0-0.2,0-0.2,0.1-0.2c1,0,1.7-0.1,2.1-0.2c0.4-0.1,0.7-0.4,0.9-0.8s0.2-1,0.2-1.8V4.6c0-0.8-0.1-1.4-0.2-1.8S85.7,2.1,85.3,2s-1.1-0.2-2-0.2c-0.1,0-0.1-0.1-0.1-0.2s0-0.2,0.1-0.2l2.2,0c1.3,0,2.3,0.1,3.1,0.1c1,0,2.3,0,3.6-0.1l2.3,0c0,0,0.1,0.1,0.1,0.2s0,0.2-0.1,0.2c-1,0-1.7,0.1-2.2,0.2s-0.8,0.5-1,0.8C91,3.2,91,3.8,91,4.7V13h13.3V4.7c0-0.8-0.1-1.4-0.2-1.8c-0.2-0.4-0.5-0.7-1-0.8s-1.2-0.2-2.2-0.2c-0.1,0-0.1-0.1-0.1-0.2s0-0.2,0.1-0.2l2,0c1.4,0,2.6,0.1,3.7,0.1c0.7,0,1.8,0,3.2-0.1l2.3,0c0.1,0,0.1,0.1,0.1,0.2s0,0.2-0.1,0.2c-0.9,0-1.6,0.1-2.1,0.2c-0.5,0.2-0.7,0.4-0.9,0.8c-0.2,0.4-0.2,1-0.2,1.8v19.1c0,0.8,0.1,1.4,0.2,1.8c0.2,0.4,0.5,0.7,0.9,0.8c0.4,0.1,1.1,0.2,2.1,0.2C112.2,26.5,112.2,26.6,112.2,26.8z" />
                  <path d="M134,20.4c0.1,0,0.2,0,0.2,0.1c0.1,0,0.1,0.1,0.1,0.1c-0.3,2.1-0.4,4.1-0.4,5.9c0,0.2,0,0.4-0.1,0.5c-0.1,0.1-0.2,0.1-0.5,0.1h-18.2c-0.1,0-0.1-0.1-0.1-0.2c0-0.2,0-0.2,0.1-0.2c0.9,0,1.5-0.1,1.9-0.2c0.4-0.1,0.7-0.4,0.8-0.8c0.1-0.4,0.2-1,0.2-1.8V4.6c0-0.8-0.1-1.4-0.2-1.8c-0.1-0.4-0.4-0.7-0.8-0.8c-0.4-0.2-1-0.2-1.9-0.2c-0.1,0-0.1-0.1-0.1-0.2s0-0.2,0.1-0.2h17.5c0.3,0,0.4,0.1,0.4,0.4l0.1,5.5c0,0-0.1,0.1-0.2,0.1c-0.2,0-0.2,0-0.3-0.1c-0.4-1.6-1.2-2.8-2.2-3.6s-2.4-1.2-4.1-1.2H125c-0.8,0-1.4,0.2-1.8,0.5c-0.4,0.4-0.6,0.9-0.6,1.7V13h3.4c1.6,0,2.8-0.3,3.7-0.8c0.9-0.5,1.3-1.3,1.3-2.3c0-0.1,0.1-0.1,0.2-0.1s0.2,0,0.2,0.1l0,3.7l0,2c0,0.9,0.1,1.7,0.1,2.2c0,0-0.1,0.1-0.2,0.1c-0.2,0-0.2,0-0.2-0.1c0-1.1-0.4-2-1.3-2.6c-0.9-0.7-2.1-1-3.7-1h-3.4v9.3c0,0.8,0.2,1.4,0.5,1.8s0.8,0.6,1.4,0.6h1.4c2.1,0,3.9-0.4,5.2-1.3C132.3,23.6,133.3,22.3,134,20.4C133.8,20.4,133.9,20.4,134,20.4z" />
                </g>
                <g fill="#ffffff">
                  <path d="M148.9,2.7h4c0.4-0.9,0.7-1.5,0.9-1.7c0.2-0.2,0.3-0.3,0.4-0.3c0.3,0,1,0.3,2,1c1.1,0.6,1.7,1.1,1.9,1.2c0.2,0.2,0.3,0.4,0.3,0.5c0,0.4-0.4,0.7-1.2,0.9v17c0,0.5,0,0.8,0.2,1c0.1,0.2,0.2,0.4,0.5,0.5c0.2,0.1,0.7,0.1,1.4,0.1c0.7,0,1.3-0.1,1.7-0.3c0.4-0.2,0.8-0.7,1.1-1.3c0.3-0.7,0.7-1.9,1.2-3.6c0.1-0.2,0.2-0.3,0.3-0.3s0.2,0.1,0.2,0.4c-0.1,0.8-0.2,1.5-0.2,2.1c0,0.6,0.1,1.1,0.3,1.5s0.6,1,1.4,1.5c0.4,0.3,0.7,0.7,0.7,1c0,0.5-0.4,1.1-1.2,1.6s-2.9,0.8-6.3,0.8c-1.9,0-3.2-0.2-3.9-0.7c-0.7-0.5-1.1-1.5-1.1-3.2V3.7h-4.5c-0.1,0.2-0.2,0.5-0.2,1l0.1,2.8c0,1.1,0.1,2.2,0.1,3.4c0,3.1-0.2,5.6-0.7,7.2c-0.5,1.7-1.2,3.1-2.2,4.2s-2.5,2.2-4.5,3.3c-2,1.1-3.1,1.6-3.4,1.6c-0.1,0-0.1,0-0.1-0.1c0-0.1,0.2-0.3,0.5-0.5c2.2-1.7,3.7-3.1,4.5-4.3c0.8-1.2,1.4-2.5,1.7-4.1c0.3-1.6,0.5-4.3,0.5-8s-0.1-6.7-0.3-8.9C146.2,1.6,147.5,2.1,148.9,2.7z" />
                  <path d="M182.3,2.8c-1.9,2.9-3.8,5.1-5.8,6.8c-1.9,1.7-3.9,2.9-5.7,3.8c-1.9,0.9-3,1.3-3.3,1.3c-0.1,0-0.2,0-0.2-0.1s0.1-0.2,0.2-0.2c2.7-1.4,5-3.4,7-5.9c1.9-2.5,3.4-5.3,4.2-8.5c1.8,0.3,3.1,0.5,3.9,0.8c0.8,0.3,1.2,0.5,1.2,0.7c0,0.2-0.2,0.3-0.6,0.5c-0.2,0.1-0.4,0.2-0.5,0.4c1,1.9,2.6,3.5,4.8,4.9c2.1,1.4,4.6,2.4,7.6,3.2c0.2,0,0.3,0.1,0.3,0.2s-0.2,0.2-0.7,0.5c-0.5,0.2-0.9,0.6-1.3,1c-0.4,0.4-0.8,1-1.2,1.9c-0.1,0.2-0.2,0.2-0.3,0.2c-0.3,0-1.4-0.7-3.3-2s-3.3-2.7-4.2-4.2C183.3,6.5,182.7,4.8,182.3,2.8z M176.4,16.8h8.7c0.2-0.5,0.5-0.9,0.7-1.2c0.2-0.3,0.4-0.4,0.6-0.4c0.2,0,0.7,0.2,1.5,0.7c0.8,0.5,1.4,0.8,1.9,1.1c0.5,0.3,0.7,0.6,0.7,0.8c0,0.2-0.3,0.5-0.9,0.7v5.4c0,1.1,0,1.8,0,2.1l0,0.8c0,0.1,0,0.2-0.2,0.3c-0.1,0.1-0.5,0.2-1,0.3c-0.6,0.1-1.2,0.2-1.7,0.2c-0.5,0-0.8,0-0.9-0.1c-0.1-0.1-0.1-0.3-0.1-0.6v-1.4h-9.4v1.3c0,0.2-0.1,0.3-0.3,0.5c-0.2,0.1-0.5,0.2-1.1,0.3c-0.5,0.1-1,0.2-1.5,0.2c-0.5,0-0.7,0-0.8,0c-0.1,0-0.1-0.1-0.1-0.2l0.1-1.3c0-0.6,0.1-1.1,0.1-1.6v-6.4c0-0.9,0-1.7-0.1-2.6C174,15.9,175.3,16.3,176.4,16.8z M183.3,11.9c0.5-0.9,0.8-1.4,0.9-1.6c0.2-0.2,0.3-0.3,0.4-0.3c0.2,0,0.8,0.4,1.6,1.1c0.9,0.7,1.3,1.2,1.3,1.4c0,0.2-0.2,0.3-0.5,0.3h-11c-0.4,0-0.7,0.1-1.1,0.3l-0.8-1.4c0.5,0.1,1,0.1,1.5,0.1C175.7,11.9,183.3,11.9,183.3,11.9z M185.8,24.5v-6.7h-9.1c-0.1,0.1-0.2,0.2-0.2,0.3v6.4C176.4,24.5,185.8,24.5,185.8,24.5z" />
                </g>
              </svg>
            </div>
            <div class="bottom-intro">{{info.company_difference}}</div>
          </div>
        </el-col>
        <el-col :span="8" :xs="24" :class="screenWidth<=768?'pt-50':''">
          <div :class="screenWidth<=768?'':'pl-60'">
            <div class="bottom-title serif fw-600" :class="screenWidth<=768?'mb-10':' mb-20'">
              {{info.title1}}
              <div class="default-font dis-ib fs-16 pr white lf--2">
                作品
              </div>
            </div>
            <ul :class="screenWidth>1200?'footer-list':'footer-list2'">
              <li @click="viewWorks(n)" v-for="(n, idx) in worksList" v-if="idx < 6" :key="idx">
                <a>{{n.work_title}}</a>
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :span="8" :xs="24" :class="screenWidth<=768?'pt-50':''">
          <div :class="screenWidth<=768?'':'pl-60'">
            <div class="bottom-title serif fw-600" :class="screenWidth<=768?'mb-10':' mb-20'">
              {{info.title2}}
              <div class="default-font dis-ib fs-16 pr white lf--2">
                观点
              </div>
            </div>
            <ul :class="screenWidth>1200?'footer-list':'footer-list2'">
              <li @click="viewPosts(n)" v-for="(n, idx) in postsList" v-if="idx < 6" :key="idx">
                <a>{{n.ins_title}}</a>
              </li>
            </ul>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Bottom',
  computed: {
    ...mapGetters([
      'screenHeight',
      'hotPosts',
      'hotWorks',
      'hotWorkList',
      'hotPostList',
      'sloganInfo',
      'routerInfo',
      'screenWidth'
    ])
  },
  data () {
    return {
      worksList: [],
      postsList: [],
      info: {},
      routerList: []
    }
  },
  watch: {
    hotPosts (val) {
      if (val) {
        this.readPosts(this.$.s2o(val).ids)
      }
    },
    hotWorks (val) {
      if (val) {
        this.readWorks(this.$.s2o(val).ids)
      }
    },
    sloganInfo (val) {
      if (val) {
        this.info = this.$.s2o(val)
        this.$.s('sloganInfo', val)
      }
    },
    routerInfo (val) {
      if (val) {
        this.routerList = this.$.s2o(val)
        this.$.s('routerInfo', val)
      }
    }
  },
  mounted () {
    if (this.hotWorkList) {
      this.worksList = this.$.s2o(this.hotWorkList)
    }
    if (this.hotPostList) {
      this.postsList = this.$.s2o(this.hotPostList)
    }
    // 路由
    if (this.$.g('routerInfo')) {
      this.routerList = this.$.s2o(this.$.g('routerInfo'))
    }
    // 不同
    if (this.$.g('sloganInfo')) {
      this.info = this.$.s2o(this.$.g('sloganInfo'))
    }
  },
  methods: {
    /*
    * 跳转作品
    */
    viewWorks (val) {
      let routeUrl = this.$router.resolve({
        path: '/works/' + val.id
      })
      window.open(routeUrl.href, '_blank')
    },
    /*
    * 跳转文章
    */
    viewPosts (val) {
      let routeUrl = this.$router.resolve({
        path: '/posts/' + val.id
      })
      window.open(routeUrl.href, '_blank')
    },
    /*
    * 查询热门作品
    */
    readWorks (ids) {
      this.worksList = []
      this.get({
        url: 'webWorksPull',
        data: {
          ids: this.$.o2s(ids)
        }
      }, (r) => {
        if (r.code) {
          this.worksList = r.data
          this.$store.commit('updateHotWorkList', this.$.o2s(r.data))
        }
      })
    },
    /*
    * 查询热门文章
    */
    readPosts (ids) {
      this.postsList = []
      this.get({
        url: 'webInsightPull',
        data: {
          ids: this.$.o2s(ids)
        }
      }, (r) => {
        if (r.code) {
          this.postsList = r.data
          this.$store.commit('updateHotPostList', this.$.o2s(r.data))
        }
      })
    }
  }
}
</script>

<style lang="less">
.footer-list,.footer-list2 {
  list-style-type: none;
  padding-left: 0;
}
.bottom-logo {
  width: 150px;
  margin-bottom: 26px;
}
.footer-list a,.footer-list2 a {
  left: 0;
  position: relative;
  transition: all .3s;
  display: inline-block;
  padding: 11px 0;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  text-overflow:ellipsis;
  list-style-type: circle;
  font-size: 14px;
}
.footer-list2 a {
  padding: 8px 0;
}
.footer-menu {
  margin-top: 30px;
  margin-bottom: 40px;
  list-style-type: none;
  padding-left: 60px;
}
.footer-menu li {
  transition: all .3s;
  margin-right: 30px;
  display: inline-block;
  position: relative;
  padding: 10px 0px;
}
.footer-menu li:hover {
  color: #f84525;
  cursor: pointer;
}
.footer-list a:hover {
  left: 10px;
  color: #f84525;
  cursor: pointer;
  position: relative;
  opacity: 1;
}
.footer-list a::after {
  content: '';
  display: block;
  width: 0%;
  height: 1px;
  transition: all 1s cubic-bezier(0.075, 0.82, 0.165, 1);
  background-color: #f84525;
  position: absolute;
  left: 0;
  bottom: 0;
}
.footer-list a:hover::after {
  width: 100%;
}
.bottom-icon-item {
  height: 3em;
  width: 3em;
}
.bottom-icon {
  padding-bottom: 3em;
}
.bottom-title {
  font-size: 1.8em;
}
.bottom-intro {
  font-size: 14px;
  line-height: 26px;
}
@media screen and (min-width: 768px) and (max-width: 992px) {
  .bottom-icon-item {
    height: 45px;
    width: 45px;
  }
  .bottom-icon {
    padding-bottom: 45px;
  }
  .bottom-title {
    font-size: 3
  }
  .bottom-title {
    font-size: 28px;
  }
}
@media screen and (min-width: 992px) and (max-width: 1200px) {
  .bottom-icon-item {
    height: 50px;
    width: 50px;
  }
  .bottom-icon {
    padding-bottom: 50px;
  }
  .bottom-title {
    font-size: 30px;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1920px) {
  .bottom-icon-item {
    height: 55px;
    width: 55px;
  }
  .bottom-icon {
    padding-bottom: 55px;
  }
  .bottom-title {
    font-size: 32px;
  }
  .bottom-intro {
    font-size: 14px;
    line-height: 28px;
  }
  .footer-list a,.footer-list2 a {
    padding: 10px 0;
  }
  .bottom-logo {
    width: 170px;
    margin-bottom: 30px;
  }
}
@media screen and (min-width: 1920px) {
  .bottom-icon-item {
    height: 60px;
    width: 60px;
  }
  .bottom-icon {
    padding-bottom: 60px;
  }
  .bottom-title {
    font-size: 34px;
  }
  .bottom-intro {
    font-size: 16px;
    line-height: 30px;
  }
  .footer-list a,.footer-list2 a {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/compos/Bottom.vue